// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2i_7b","buttons":"PendingPaymentAlert_buttons__2VBpj"};